<script>
    import DefaultComponent from '../defaultComponent';

    export default {
        ...DefaultComponent
    }
</script>

<template>
    <a :href="item.url" class="card profilelink is-shadowless">
        <div v-if="item.imageSets && item.imageSets.length" class="card-image">
            <source-set :imageSets="item.imageSets" classes="is-rounded is-profile mx-auto" />
        </div>
        <div class="card-content is-flex-grow-1 is-flex is-flex-direction-column">
            <h4 v-show="item.name" class="title is-4">{{ item.name }}</h4>
            <p v-show="item.profession" class="is-size-body has-text-grey-darker">{{ item.profession }}</p>
        </div>
    </a>
</template>
